/**
 * Shared keyboard-shortcut notation for the help center: the capture UI in
 * HelpCenterModal and the app-wide dispatcher (useShortcutDispatcher) must
 * agree on how a pressed combo is written ("Mod+Shift+P" and friends).
 */

export const MODIFIER_KEYS = ['Control', 'Meta', 'Shift', 'Alt'];

export const FOCUS_TARGET_CLASS = 'help-focus-target';
export const FOCUS_CLEANUP_DELAY_MS = 2600;

/** Normalize a physical key into the notation stored in shortcut assignments. */
export function normalizeCapturedKey(key: string): string {
  if (key === ' ') return 'Space';
  if (key === 'Escape') return 'Esc';
  if (key.length === 1) return key.toUpperCase();
  return key;
}

/** Join the pressed modifiers with the normalized key into the stored combo. */
export function comboOfEvent(event: KeyboardEvent): string {
  const parts: string[] = [];
  if (event.metaKey || event.ctrlKey) parts.push('Mod');
  if (event.shiftKey) parts.push('Shift');
  if (event.altKey) parts.push('Alt');
  parts.push(normalizeCapturedKey(event.key));
  return parts.join('+');
}

/** Flash-highlight the feature's target element and scroll it into view. */
export function highlightTarget(elementId: string): void {
  const element = document.getElementById(elementId);
  if (!element) return;
  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  element.classList.add(FOCUS_TARGET_CLASS);
  window.setTimeout(() => element.classList.remove(FOCUS_TARGET_CLASS), FOCUS_CLEANUP_DELAY_MS);
}
